function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionSurpriseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16C2 8.28 8.28 2 16 2s14 6.28 14 14-6.28 14-14 14S2 23.72 2 16zm1.974 0c0 6.631 5.395 12.026 12.026 12.026 6.63 0 12.026-5.395 12.026-12.026S22.631 3.974 16 3.974 3.974 9.369 3.974 16z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.704 11.047a1.86 1.86 0 00-1.858 1.859 1.86 1.86 0 001.858 1.858 1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.859-1.859zM21.296 11.047a1.86 1.86 0 00-1.859 1.859 1.86 1.86 0 001.858 1.858 1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.858-1.859zM16.037 23.956a2.896 2.896 0 100-5.791 2.896 2.896 0 000 5.79z",
    fill: props.color
  }));
}

export default SvgIconEmotionSurpriseFilled;